import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import { BizTitle, Department, Location, MEDIUM_ITEM_SIZE } from "./_fields";
import { validatePlainText, validateEmail } from "./_utils";

type ConfigEmployeeTemplate = {
  eEmployeeId: string;
  Title: string;
  eDepartment: string;
  eMail: string;
  eBizTitle: string;
  eLocation: string;
  ePhone: string;
};

const currentDate = new Date();
const tomorrow = new Date();
tomorrow.setDate(currentDate.getDate() + 1);

export const configEmployeeTemplate: TemplatesValue<ConfigEmployeeTemplate> = {
  fileName: "DanhSachNhanVien",
  sheet: DEFAULT_SHEET_NAME,
  structures: [
    {
      header: "Mã nhân viên",
      value: "001792",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
    {
      header: "Tên nhân viên",
      value: "Nguyễn Văn Thanh",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
    Department,
    {
      header: "Email",
      value: "canbo2@viags.vn",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validateEmail,
    },
    BizTitle,
    Location,
    {
      header: "Số điện thoại",
      value: "0123123123",
      itemSize: MEDIUM_ITEM_SIZE,
      validate: validatePlainText,
    },
  ],
  fields: ["eEmployeeId", "Title", "eDepartment", "eMail", "eBizTitle", "eLocation", "ePhone"],
};
